import { createSwrListStore } from './swr/createSwrListStore';
import { listProjects } from '../lib/api';

const DEFAULT_LIMIT = 12;

/**
 * Default-view projects cache: page 1, all statuses, no search.
 * Filtered/paginated queries are NOT cached — they always fetch fresh.
 */
const swr = createSwrListStore({
  name: 'ProjectsStore',
  storageKey: 'bookthing-projects',
  itemsField: 'projects',
  setters: {
    set: 'setProjects',
    add: 'addProject',
    update: 'updateProject',
    remove: 'removeProject',
    reset: 'resetProjects',
  },
  fetcher: async () => {
    const resp = await listProjects({
      page: 1,
      limit: DEFAULT_LIMIT,
      status: null,
      search: null,
    });
    return resp.projects || [];
  },
});

export const useProjectsStore = swr.useStore;
export const useProjectsData = swr.useData;
export const fetchProjectsIfStale = swr.fetchIfStale;
